import { render, staticRenderFns } from "./DashboardVerification.vue?vue&type=template&id=36166fa8&"
import script from "./DashboardVerification.vue?vue&type=script&lang=js&"
export * from "./DashboardVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports